<fieldset>
  <legend class="filter__fieldLegend headingXS">{{ filter.label }}</legend>
  <ul class="list formfield__inputGroup">
    <li
      class="list__item filter__inputGroupItem"
      *ngFor="let filterOption of filterOptions"
    >
      <app-filtertype-checkbox
        [form]="form"
        [formControl]="filter.name"
        [filter]="filter"
        [filterOption]="filterOption"
      ></app-filtertype-checkbox>
    </li>
  </ul>
</fieldset>
